import React, { useEffect } from "react";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
// Util
import { auth } from "../../utils/firebase/firebase";
import { cLog } from "../../utils/log_util";

function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.currentUser) {
      signOut(auth)
        .then(() => {
          alert("You are signed out!");
          navigate("/");
        })
        .catch((err) => {
          alert("Something's wrong with signing you out!");
          cLog(err);
        });
    } else {
      navigate("/");
    }
  }, []);

  return null;
}

export default Logout;
